// extracted by mini-css-extract-plugin
export default {"root":"InvoiceDetailAnalysisConclusionList_root__joxwL","subheadingItem":"InvoiceDetailAnalysisConclusionList_subheadingItem__WmMW-"};